


































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRatingBar from '@/components/AppRatingBar.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRatingBar
  }
})
export default class extends Mixins(Common) {
  @Prop(Object) readonly review!: object
  @Prop(Boolean) readonly showOption!: boolean
  @Prop(Boolean) readonly expanded!: boolean
}
